import { searchParam, useSetSearch } from '@luminovo/design-system';
import { ComponentMetricIdSchema } from '@luminovo/monitoring-contracts';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { ComponentSavingsPage } from '@/areas/market-insights/MarketInsights/pages/ComponentSavingsPage/ComponentSavingsPage';
import { canViewSavingsReport } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/components/categories/$categoryId/pricing')({
    staticData: { access: { permissions: canViewSavingsReport }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: z.object({
        baseline: searchParam.enum(ComponentMetricIdSchema.enum, 'optional'),
        comparison: searchParam.enum(ComponentMetricIdSchema.enum, 'optional'),
        period: z.string().optional(),
        ipn: z.string().optional(),
    }),
    remountDeps: ({ params }) => params.categoryId,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { categoryId } = Route.useParams();
    const baseline = Route.useSearch({ select: (search) => search.baseline });
    const comparison = Route.useSearch({ select: (search) => search.comparison });
    const period = Route.useSearch({ select: (search) => search.period });
    const ipn = Route.useSearch({ select: (search) => search.ipn });
    const onSearchChange = useSetSearch();
    return (
        <ComponentSavingsPage
            categoryId={categoryId}
            baseline={baseline}
            comparison={comparison}
            period={period}
            ipn={ipn}
            onSearchChange={onSearchChange}
        />
    );
}
